import { render } from "./SwiperBanner.vue?vue&type=template&id=064949f4&scoped=true"
import script from "./SwiperBanner.vue?vue&type=script&lang=js"
export * from "./SwiperBanner.vue?vue&type=script&lang=js"

import "./SwiperBanner.vue?vue&type=style&index=0&id=064949f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064949f4"]])

export default __exports__